/**
 * Texte localisé (enums#localized_text) : locale de l'utilisateur, puis français, puis la première
 * disponible. Un libellé absent n'est jamais inventé : l'identifiant technique sert de repli.
 */
export type LocalizedText = Readonly<Record<string, string>>;

export function text(value: LocalizedText | string | undefined | null, locale = 'fr', fallback = ''): string {
  if (value === undefined || value === null) return fallback;
  if (typeof value === 'string') return value;
  return value[locale] ?? value['fr'] ?? Object.values(value)[0] ?? fallback;
}
